import type {MergeContext, QuoteTemplate} from './types';
import {resolvePlateValue} from './resolvePlateValue';

/**
 * Replaces every mention node in the template's authored sections with its resolved value. The
 * result is what gets RENDERED; it is never what gets persisted — the stored payload keeps its
 * tokens unresolved so a reopened quote re-resolves them against the live project.
 */
export function resolveTemplate(template: QuoteTemplate, ctx: MergeContext): QuoteTemplate {
	return {
		...template,
		sections: template.sections.map(section => ({...section, body: resolvePlateValue(section.body, ctx)})),
	};
}
